<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding toolbar-shadow"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click.prevent color="#ec514f" :ripple="false">
          <v-icon size="16px" >$vuetify.icons.confirm</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">상담 신청 완료</h3>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile class="my-3 mx-3 pt-4 card-style">
          <v-img class="mt-3 mb-5" style="margin: auto;" width="151px" :src="require('@/assets/img/yuni-congratulations.png')"></v-img>
          <v-divider style="margin-left: 10px; margin-right: 10px; border-style: dashed;"></v-divider>
          <v-card-title style="font-size: 32px; font-weight: 700; letter-spacing: -0.5px; color: #ec2f54;">
            <span style="margin: auto;">신청 완료!</span>
          </v-card-title>
          <v-card-text>
            <p>상담이 신청되었습니다 👏<br>
              상담 신청 내용은 카카오톡으로 안내드릴 예정입니다.<br>
              성공적인 유학을 위해 유스가 도와드릴게요! 😊</p>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card tile class="my-3 mx-3 py-3 card-style">
          <v-layout row>
            <v-flex xs6>
              <v-btn class="ma-0 display-2" block flat @click="$router.push({ name: 'Store' })">스토어 메인으로</v-btn>
            </v-flex>
            <v-divider></v-divider>
            <v-flex xs6>
              <v-btn class="ma-0 display-2" block flat @click="$router.go(-1)">이전으로</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'ConsultingFormComplete'
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  .card-style {
    position: relative;
    border-radius: 5px !important;
    box-shadow: 0 10px 10px rgba(#9b9b9b, 0.25) !important;
  }
</style>
